// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  flex-direction: column;
}

.list-wrapper ul li {
  color: var(--textsecondarycolor) !important;
}
.list-wrapper ul li.active {
  background: var(--listbackgoundhover) !important;
  color: var(--listcolor) !important;
  border-right: 2px solid #1571b9;
  border-radius: 6px;
  font-weight: 600;
}
.list-wrapper ul li.active .list-active,
.list-wrapper ul li.active a {
  color: var(--listcolor) !important;
}
.list-wrapper ul li.active ::ng-deep .empty-img {
  background: #1571b9 !important;
  color: #fff !important;
}
.list-wrapper ul li:hover {
  background: var(--listbackgoundhover) !important;
}
.list-wrapper ul li:hover a {
  color: var(--listcolor) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/video-quiz/video-quiz.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAII;EAEE,2CAAA;AAFN;AAMI;EACE,gDAAA;EACA,kCAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AAJN;AAMM;;EAEE,kCAAA;AAJR;AAOM;EACE,8BAAA;EACA,sBAAA;AALR;AAUI;EACE,gDAAA;AARN;AAUM;EACE,kCAAA;AARR","sourcesContent":[":host {\n  flex-direction: column;\n}\n\n.list-wrapper {\n  ul {\n    li {\n\n      color: var(--textsecondarycolor) !important;\n\n    }\n\n    li.active {\n      background: var(--listbackgoundhover) !important;\n      color: var(--listcolor) !important;\n      border-right: 2px solid #1571b9;\n      border-radius: 6px;\n      font-weight: 600;\n\n      .list-active,\n      a {\n        color: var(--listcolor) !important;\n      }\n\n      ::ng-deep .empty-img {\n        background: #1571b9 !important;\n        color: #fff !important\n      }\n\n    }\n\n    li:hover {\n      background: var(--listbackgoundhover) !important;\n\n      a {\n        color: var(--listcolor) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
